import { cx } from "@emotion/css";
import { useTranslation } from "react-i18next";
import {
	type ExamDepartmentStats,
	getExamChartSegments,
} from "src/components/Modals/StatisticsModals/examStatsTypes";
import { DeckCircleChart } from "src/components/Statistics/flashcards/DeckCircleChart";
import { useFontSize } from "src/hooks/useFontSize";

interface ExamCategoriesStatsProps {
	departments: ExamDepartmentStats[];
}

export const ExamCategoriesStats = ({
	departments,
}: ExamCategoriesStatsProps) => {
	const { t } = useTranslation();
	const { modalHeaderFontSizeClass } = useFontSize();

	if (!departments.length) {
		return (
			<div className="flex flex-col items-center gap-8 mt-24">
				<span className="size-18-light">
					{t("modals.statistics.empty.title", "Nie znaleziono danych")}
				</span>
				<span className="size-16-light text-grey text-center">
					{t("modals.statistics.empty.description")}
				</span>
			</div>
		);
	}

	return (
		<div className="flex flex-col gap-8 mt-24 container-inline">
			<span className={cx(modalHeaderFontSizeClass, "font-semibold")}>
				{t("modals.statistics.categoriesTitle", "Wyniki wg kategorii")}
			</span>
			<div className="flex flex-col list-divided">
				{departments.map((department) => (
					<div
						key={department.departmentName}
						className="flex items-center gap-16 py-12"
					>
						<DeckCircleChart
							className="circle-chart--small"
							segments={getExamChartSegments(department)}
							total={department.totalQuestions}
						/>
						<div className="flex flex-col gap-8 flex-1 min-w-0">
							<span className="size-16">{department.departmentName}</span>
							<div className="flex flex-wrap gap-8">
								<span className="chip chip--status tint-success">
									{t("modals.statistics.correctCount", "{{count}} poprawnych", {
										count: department.correctAnswers,
									})}
								</span>
								<span className="chip chip--status tint-error">
									{t("modals.statistics.wrongCount", "{{count}} błędnych", {
										count: department.wrongAnswers,
									})}
								</span>
							</div>
						</div>
					</div>
				))}
			</div>
		</div>
	);
};
